export const NAV = {
  brand: "nav-brand-logo",
  home: "nav-link-home",
  services: "nav-link-services",
  industries: "nav-link-industries",
  aiTransformation: "nav-link-ai-transformation",
  about: "nav-link-about",
  contact: "nav-link-contact",
  countriesTrigger: "nav-countries-trigger",
  ctaHeader: "nav-cta-strategy-session",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};

export const LEAD_FORM = {
  root: "lead-form",
  stepIndicator: "lead-form-step-indicator",
  countrySelect: "lead-form-country",
  skillChip: (slug) => `lead-form-skill-${slug}`,
  teamSizeOption: (slug) => `lead-form-team-size-${slug}`,
  durationOption: (slug) => `lead-form-duration-${slug}`,
  name: "lead-form-name",
  email: "lead-form-email",
  company: "lead-form-company",
  message: "lead-form-message",
  back: "lead-form-back",
  next: "lead-form-next",
  submit: "lead-form-submit",
  success: "lead-form-success",
  error: "lead-form-error",
};

export const FINAL_CTA = {
  root: "final-cta-section",
  button: "final-cta-button",
};

export const FOOTER = {
  root: "site-footer",
};
